export default __webpack_public_path__ + "aacd247e9c9a4528f31c51effaeb7ebb.png";